import React from 'react';

import { Button as Component } from './styles';

function Button({ children, handlePress }) {
  return (
    <Component type='button' onClick={handlePress}>
      {children}
    </Component>
  );
}

export default Button;
